<template>
  <div>
    <q-form ref="editForm">
      <c-card title="기본정보" class="cardClassDetailForm">
        <template slot="card-button">
          <q-btn-group outline >
            <c-btn
              v-show="patrol.patrolStepCd === 'PS00000010'"
              label="출력"
              icon="print"
              @btnClicked="printPatrol" />
            <c-btn 
              v-show="isOld && !deleteDisabled && editable" 
              label="삭제" 
              icon="delete_forever" 
              @btnClicked="removePlan" />
            <c-btn
              v-show="!completeDisabled && editable"
              :url="saveUrl"
              :isSubmit="isSave"
              :param="patrol"
              :mappingType="actionType"
              label="임시저장"
              icon="save"
              @beforeAction="savePlan"
              @btnCallback="saveCallback" 
            />
            <c-btn
              v-show="isOld && !disabled && editable"
              :url="completeUrl"
              :isSubmit="isComplete"
              :param="patrol"
              mappingType="PUT"
              label="계획완료"
              icon="check"
              @beforeAction="completePlan"
              @btnCallback="completeCallback" 
            />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-datepicker
              :required="true"
              :editable="editable"
              :disabled="completeDisabled"
              label="순회일"
              name="patrolStartDate"
              v-model="patrol.patrolStartDate"
              @datachange="datachangeDate"
            />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-text
              :required="true"
              :editable="editable"
              :disabled="disabled"
              label="순회명"
              name="patrolName"
              v-model="patrol.patrolName">
            </c-text>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-dept
              :required="true"
              :editable="editable"
              :disabled="disabled"
              label="점검주관부서"
              name="deptCd"
              v-model="patrol.deptCd"
              @setDeptName="(deptName) => { patrol.deptName = deptName }"
            />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
            <c-plant 
              :required="true"
              :disabled="disabled"
              :editable="editable" 
              type="edit" 
              name="plantCd" 
              v-model="patrol.plantCd"
              @datachange="datachange" />
          </div>
          <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
            <c-multi-field
              :required="true"
              :editable="editable"
              :data="patrol"
              :disabled="disabled"
              label="점검자"
              type="user"
              name="checkUserId"
              v-model="patrol.checkUserId">
            </c-multi-field>
          </div>
        </template>
      </c-card>
      <c-table
        ref="table"
        title="순회 장소 목록"
        :columns="grid.columns"
        :gridHeight="gridHeight"
        :data="patrol.places"
        :filtering="false"
        :columnSetting="false"
        :usePaging="false"
        :hideBottom="true"
        :editable="editable && !disabled"
        rowKey="saiPatrolPlaceId"
        selection="multiple"
      >
        <template slot="table-button">
          <q-btn-group outline>
            <c-btn
              v-if="editable && !disabled"
              :showLoading="false"
              label="추가"
              icon="add"
              @btnClicked="addPlace"
            />
            <c-btn
              v-if="editable && !disabled"
              :disabled="!patrol.places || patrol.places.length === 0"
              label="제외"
              icon="remove"
              @btnClicked="removePlace"
            />
          </q-btn-group>
        </template>
        <template v-slot:customArea="{ props, col }">
          <template v-if="props.row.lines && props.row.lines.length > 0">
            <q-chip
              v-for="(line, index) in props.row.lines"
              :key="index"
              outline square 
              :removable="!disabled&&editable"
              color="primary"
              text-color="white"
              class="q-ma-none customchipdept"
              @remove="removeLine(props.row, line)">
              {{line.lineCd}}
            </q-chip>
          </template>
          <q-chip v-if="editable && !disabled"
            clickable @click="addLine(props, col)" color="primary" text-color="white" icon="add">
            추가
          </q-chip>
        </template>
      </c-table>
    </q-form>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'patrol-plan-info',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        saiPatrolId: '',
      }),
    },
    patrol: {
      type: Object,
      default: () => ({
        saiPatrolId: '',  // 순회점검 일련번호
        plantCd: '',  // 사업장 코드
        patrolName: '',  // 순회명
        patrolStartDate: '',  // 순회시작일
        patrolEndDate: '',  // 순회종료일
        deptCd: '',  // 점검부서 코드
        deptName: '',  // 점검부서
        patrolResultCd: null,  // 특이사항
        patrolResultSummary: '',  // 순회결과요약
        patrolStepCd: null,  // 진행상태
        checkUserId: '',
        regUserId: '',  //
        places: [],
        deletePlaces: [],
        imprs: [],
      }),
    },
    contentHeight: null,
  },
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'placeName',
            field: 'placeName',
            label: '장소',
            align: 'center',
            style: 'width:25%',
            sortable: false,
          },
          {
            name: 'lines',
            field: 'lines',
            label: 'Line',
            align: 'center',
            style: 'width:75%',
            sortable: false,
            type: 'custom',
            required: true,
          },
        ],
        height: "320px",
        data: [],
      },
      addRow: null,
      actionType: 'POST',
      editable: true,
      isSave: false,
      isComplete: false,
      saveUrl: '',
      deleteUrl: '',
      completeUrl: '',
      printUrl: '',
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    gridHeight() {
      return String(this.contentHeight - 285) + 'px';
    },
    isOld() {
      return Boolean(this.popupParam.saiPatrolId)
    },
    disabled() {
      return this.patrol.patrolStepCd === 'PS00000005' || this.patrol.patrolStepCd === 'PS00000010';
    },
    completeDisabled() {
      return this.patrol.patrolStepCd === 'PS00000010';
    },
    deleteDisabled() {
      return false; // this.patrol.patrolStepCd === 'PS00000010';
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.saveUrl = transactionConfig.sai.patrol.insert.url;
      this.deleteUrl = transactionConfig.sai.patrol.delete.url;
      this.completeUrl = transactionConfig.sai.patrol.complete.url;
      this.printUrl = selectConfig.sai.patrol.print.url;
    },
    addPlace() {
      this.popupOptions.title = '장소'; // 장소
      this.popupOptions.param = {
        plantCd: this.patrol.plantCd,
        type: 'multiple',
      };
      this.popupOptions.target = () => import(`${'./patrolPlacePop.vue'}`);
      this.popupOptions.width = '35%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    closePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.patrol.places, { placeId: item.placeId }) === -1) {
            this.patrol.places.splice(0, 0, {
              saiPatrolPlaceId: uid(),  // 순회점검 결과 장소 일련번호
              saiPatrolId: this.popupParam.saiPatrolId,  // 순회점검 일련번호
              placeId: item.placeId,  // 장소번호
              placeName: item.placeName,  // 장소
              patrolPlaceStepCd: 'PPS0000001',  // 순회점검 장소 진행상태
              lines: [],
              regUserId: this.$store.getters.user.userId,
              editFlag: 'C',
            })
          }
        })
      }
    },
    removePlace() {
      let selectData = this.$refs['table'].selected;
      if (!selectData || selectData.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내', // 안내
          message: '하나 이상 선택하세요.', // 하나 이상 선택하세요.
          type: 'warning', // success / info / warning / error
        });
      } else {
        this.patrol.deletePlaces = [];
        this.$_.forEach(selectData, item => {
          if (this.$_.findIndex(this.patrol.deletePlaces, { saiPatrolPlaceId: item.saiPatrolPlaceId }) === -1
            && item.editFlag !== 'C') {
            this.patrol.deletePlaces.push(item)
          }
          this.patrol.places = this.$_.reject(this.patrol.places, item);
        })
        this.$refs['table'].$refs['compo-table'].clearSelection();
      }
    },
    /* eslint-disable no-unused-vars */
    addLine(props, col) {
      this.addRow = props.row
      this.popupOptions.title = 'Line'; // Line
      this.popupOptions.param = {
        plantCd: this.patrol.plantCd,
        type: 'multiple',
      };
      this.popupOptions.target = () => import(`${'@/pages/common/process/linePop.vue'}`);
      this.popupOptions.width = '40%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeLinePopup;
    },
    closeLinePopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.$_.forEach(data, item => {
          if (this.$_.findIndex(this.addRow, { lineId: item.lineId }) === -1) {
            this.addRow.lines.push({
              saiPatrolPlaceId: this.addRow.saiPatrolPlaceId,  // 순회점검 결과 장소 일련번호
              lineId: item.lineId,  // 라인일련번호
              lineCd: item.lineCd,  // 라인번호
            })
          }
        })
      }
    },
    removeLine(row, line) {
      row.lines.splice(this.$_.findIndex(row.lines, { lineId: line.lineId }), 1);
    },
    savePlan() {
      if (this.popupParam.saiPatrolId) {
        this.saveUrl = transactionConfig.sai.patrol.update.url;
        this.actionType = 'PUT';
      } else {
        this.saveUrl = transactionConfig.sai.patrol.insert.url;
        this.actionType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result && this.$comm.validTable(this.grid.columns, this.patrol.places)) { 
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '저장하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.patrol.regUserId = this.$store.getters.user.userId
              this.patrol.chgUserId = this.$store.getters.user.userId
              this.$_.cloneDeep(this.patrol)

              this.isSave = !this.isSave
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(_result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('transInfo', _result.data)
    },
    completePlan() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result && this.$comm.validTable(this.grid.columns, this.patrol.places)) { 
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '완료하시겠습니까?',
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.patrol.chgUserId = this.$store.getters.user.userId

              this.isComplete = !this.isComplete
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          this.patrol.patrolStepCd = 'PS00000001'
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    completeCallback() {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.$emit('transInfo', this.popupParam.saiPatrolId)
    },
    /* eslint-disable no-unused-vars */ 
    removePlan() {
      let _message = '삭제하시겠습니까?'
      if (this.patrol.imprs && this.patrol.imprs.length > 0) {
        let imprs = this.$_.filter(this.patrol.imprs, { ibmClassCd: 'IC00000001' });
        let immImprs = this.$_.filter(this.patrol.imprs, { ibmClassCd: 'IC00000005' });
        _message = `개선진행중인 데이터까지 삭제됩니다.
삭제하시겠습니까?
 * 개선건 : ${imprs ? imprs.length : 0}
 * 즉시조치건 : ${immImprs ? immImprs.length : 0}`
      }
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: _message,
        // TODO : 필요시 추가하세요.
        type: 'info', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.saiPatrolId);
          this.$http.type = 'DELETE';
          this.$http.request((_result) => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup')
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    printPatrol() {
      let thisVue = this;
      this.$http.url = this.$format(this.printUrl, this.popupParam.saiPatrolId);
      this.$http.type = 'GET';
      this.$http.request(
        _result => {
          let fileOrgNm = this.patrol.patrolName + '.xlsx';
          let blob = thisVue.$comm.base64ToBlob(_result.data);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, fileOrgNm);
          } else {
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = fileOrgNm;
            link.click();
          }
        }, () => { }
      );
    },
    datachange(newValue) {
      if (!this.patrol.deletePlaces) this.patrol.deletePlaces = [];
      this.$_.forEach(this.patrol.places, item => {
        if (this.$_.findIndex(this.patrol.deletePlaces, { saiPatrolPlaceId: item.saiPatrolPlaceId }) === -1
          && item.editFlag !== 'C') {
          this.patrol.deletePlaces.push(item)
        }
        this.patrol.places = this.$_.reject(this.patrol.places, item);
      })
      this.setResultList();
    },
    setResultList() {
      this.$http.url = selectConfig.sai.patrol.resultItem.place.line.url;
      this.$http.type = 'GET';
      this.$http.param = {
        plantCd: this.patrol.plantCd,
        itemFlag: 'Y',
      };
      this.$http.request((_result) => {
        this.patrol.places = [];
        this.$_.forEach(_result.data, _item => {

          if (_item.lines)
          this.patrol.places.push({
            saiPatrolPlaceId: uid(),  // 순회점검 결과 장소 일련번호
            saiPatrolId: this.popupParam.saiPatrolId,  // 순회점검 일련번호
            placeId: _item.placeId,  // 장소번호
            placeName: _item.placeName,  // 장소
            patrolPlaceStepCd: 'PPS0000001',  // 순회점검 장소 진행상태
            lines: _item.lines,
            regUserId: this.$store.getters.user.userId,
            editFlag: 'C',
          })
        })
      },);
    },
    datachangeDate() {
      this.patrol.patrolName = this.patrol.patrolStartDate + ' 순회점검'
    },
  }
};
</script>
